<template>
  <div class="test-wrapper">
    <div v-if="!sended">
      <p class="step">Тест завершен</p>
      <h2 class="step_name">Подсчет баллов</h2>
      <div class="img-block">
        <img class="preloader-img" src="/upload/bkc_test/BKC_BB_logo_main-02.svg">
      </div>
      <div
        class="preloader-text"
        style="color:#00bcc6;text-align:center;font-size: 17px;font-weight: 400;margin-bottom:100px;"
      >{{peloaderText}}</div>
      <div class="peloader" style="margin: 30px 0 38px 0;display: inline-block;width:100%;">
        <div class="text">Начало начал положено, теперь дальше, к заветным мечтам!</div>
      </div>
    </div>
    <result
      :questions="questions"
      :testKey="testKey"
      :category="category"
      :level="level"
      :levelId="levelId"
      v-if="sended"
    ></result>
  </div>
</template>

<script>
import axios from "axios";
import Result from "./Result";

export default {
  components: { Result },
  name: "Preloader",
  data() {
    return {
      peloaderText: "Проверяю ответы на вопросы...",
      category: "",
      sended: false,
      level: "",
      levelId: "",
      questions: [],
      testKey: "",
    };
  },
  mounted: function() {

    this.scrollToTest();
    this.sended = false;
    axios
      .get("/quiz/api/test.php?save_result&last")
      .then(response => {
        axios
          .get(`/quiz/api/test.php?get_questions&level`)
          .then(response => {
            if (
              !response.data.questions ||
              !response.data.language ||
              !response.data.category
            ) {
              alert(
                "Произошла ошибка. Если данная ошибка повторится, обратитесь к администратору. Приносим свои извинения. "
              );
              this.$router.push(`/`);
            }
            this.questions = response.data.questions;
            this.level = response.data.level;
            this.testKey = response.data.category;
            this.language = response.data.language;
            this.levelId = response.data.level_id;
            this.sended = true;
          })
          .catch(error => {
            alert(error);
          });
      })
      .catch(error => {
        alert(error);
      });
  },
  computed: {},
  methods: {
    scrollToTest: function() {
      $("html, body").animate(
        { scrollTop: $(".container-test").offset().top },
        0
      ); // анимируем скроолинг к элементу scroll_el
    }
  }
};
</script>

<style scoped lang="sass">
    .buttons_category
        div.active
            background: #6ed9de
            color: #fff

</style>



// WEBPACK FOOTER //
// src/components/Preloader.vue